import { render, staticRenderFns } from "./ContractLandParcel.vue?vue&type=template&id=68215438&scoped=true&"
import script from "./ContractLandParcel.vue?vue&type=script&lang=js&"
export * from "./ContractLandParcel.vue?vue&type=script&lang=js&"
import style0 from "./ContractLandParcel.vue?vue&type=style&index=0&id=68215438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68215438",
  null
  
)

export default component.exports